import React from 'react';
import { TableCell, TableRow, Typography } from '@mui/material';
import { useListPageStyles } from './styles';

type TableEmptyRowProps = {
  colSpan: number;
  message: string;
};

export const TableEmptyRow = ({ colSpan, message }: TableEmptyRowProps) => {
  const { classes } = useListPageStyles();

  return (
    <TableRow>
      <TableCell colSpan={colSpan}>
        <Typography variant="body2" className={classes.emptyState}>
          {message}
        </Typography>
      </TableCell>
    </TableRow>
  );
};
